import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import {
    BABOOR_ENVIRONMENT,
    BaboorEnvironmentConfig,
} from '@baboor/baboor-core'
import type {
    InsertPromotion,
    Promotion,
    PromotionQueryParams,
    UpdatePromotion,
} from '@baboor/baboor-models'
import { ApiResponse } from '@baboor/common-models'
import { toHttpParams } from '@baboor/common-util'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class PromotionsApiService {
    private apiUrl: string

    constructor(
        private http: HttpClient,
        @Inject(BABOOR_ENVIRONMENT) private env: BaboorEnvironmentConfig,
    ) {
        this.apiUrl = `${env.apiUrl}/v1/promotions`
    }

    getPromotions(
        params?: PromotionQueryParams,
    ): Observable<ApiResponse<Promotion[]>> {
        return this.http.get<ApiResponse<Promotion[]>>(`${this.apiUrl}`, {
            params: toHttpParams(params ?? {}),
        })
    }

    getPromotion(id: string): Observable<ApiResponse<Promotion>> {
        return this.http.get<ApiResponse<Promotion>>(`${this.apiUrl}/${id}`)
    }

    getActivePromotions(
        serviceId?: string,
    ): Observable<ApiResponse<Promotion[]>> {
        const params: Record<string, string> = {}
        if (serviceId) params['serviceId'] = serviceId
        return this.http.get<ApiResponse<Promotion[]>>(
            `${this.apiUrl}/active`,
            { params: toHttpParams(params) },
        )
    }

    createPromotion(data: InsertPromotion): Observable<ApiResponse<Promotion>> {
        return this.http.post<ApiResponse<Promotion>>(`${this.apiUrl}`, data)
    }

    updatePromotion(
        id: string,
        data: UpdatePromotion,
    ): Observable<ApiResponse<Promotion>> {
        return this.http.patch<ApiResponse<Promotion>>(
            `${this.apiUrl}/${id}`,
            data,
        )
    }

    deletePromotion(id: string): Observable<ApiResponse<unknown>> {
        return this.http.delete<ApiResponse<unknown>>(`${this.apiUrl}/${id}`)
    }
}
